// redux/services/occupationService/occupation.Services.js

import { baseApi } from "../baseApi";

export const OccupationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // CREATE
    createOccupation: builder.mutation({
      query: (data) => ({
        url: "/occupation-create",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: ["Occupation"],
    }),

    // GET ALL
    getOccupation: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        status = "",
      } = {}) =>
        `/occupation-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: "Occupation", id })),
              { type: "Occupation", id: "LIST" },
            ]
          : [{ type: "Occupation", id: "LIST" }],
    }),

    // GET SINGLE
    getSingleOccupation: builder.query({
      query: (id) => `/occupation-view/${id}`,
      providesTags: (result, error, id) => [{ type: "Occupation", id }],
    }),

    // UPDATE
    updateOccupation: builder.mutation({
      query: (data) => ({
        url: "/occupation-update",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Occupation", id },
        { type: "Occupation", id: "LIST" },
      ],
    }),

    // STATUS CHANGE
    changeStatusOccupation: builder.mutation({
      query: (id) => ({
        url: `/occupation-status/${id}`,
        method: "GET",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Occupation", id },
        { type: "Occupation", id: "LIST" },
      ],
    }),

    // DELETE
    deleteOccupation: builder.mutation({
      query: (data) => {
        const id = typeof data === 'object' ? data.id : data;
        return {
          url: `/occupation-delete/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: (result, error, data) => {
        const id = typeof data === 'object' ? data.id : data;
        return [
          { type: "Occupation", id },
          { type: "Occupation", id: "LIST" },
        ];
      },
    }),

    // GET ALL (without pagination - for dropdowns)
    getAllOccupation: builder.query({
      query: () => "/occupation-all",
      providesTags: ["Occupation"],
    }),
  }),
});

export const {
  useCreateOccupationMutation,
  useGetOccupationQuery,
  useGetSingleOccupationQuery,
  useUpdateOccupationMutation,
  useDeleteOccupationMutation,
  useChangeStatusOccupationMutation,
  useGetAllOccupationQuery,
} = OccupationApi;